import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";





// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";


import ProtectedRoute from "components/Routes/ProtectedRoute";
import PrivacyPolicy from "components/Tables/Privacy";
import Webpage from "components/Tables/Webpage";


ReactDOM.render(

  <BrowserRouter>
   <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
   
    <Routes>
      {/* Redirect / to /admin/dashboard */}
      <Route path="/" element={<Navigate to="/auth/login" replace />} />
        
      {/* Routes with layouts */}
      <Route
  path="/admin/*"
  element={
    <ProtectedRoute>
      <Admin />
    </ProtectedRoute>
  }
/>
      <Route path="/auth/*" element={<Auth />} />

      {/* Routes without layouts */}
      <Route path="/landing" element={<Landing />} />
      <Route path="/profile" element={<Profile />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/Webpage" element={<Webpage/>} />
      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
